import React from "react";
import { ReferalRow } from "./payrollTable";
import { Accordion, Text } from "@mantine/core";

const PayrollPaymentRefers = ({ form }) => {
  const { referals, payrollBids } = form.values;
  const hasReferals = referals && referals.length > 0;
  const isPayroll2Payment = Array.isArray(payrollBids);

  if (hasReferals) {
    return (
      <Accordion variant="separated">
        {referals.map((referal) => (
          <ReferalRow key={referal._id} referal={referal} />
        ))}
      </Accordion>
    );
  }

  return (
    <Text size="sm" color="dimmed">
      {isPayroll2Payment
        ? "No referral payments in payroll2."
        : "No referral payments found."}
    </Text>
  );
};

export default PayrollPaymentRefers;
